import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['messageInput', 'submitButton'];

  connect() {
    this.updateSubmitButtonState();
  }

  initialize() {
    this.submitButtonTarget.disabled = true;
  }

  updateSubmitButtonState() {
    const hasContent = this.messageInputTarget.value.trim() !== '';
    this.submitButtonTarget.disabled = !hasContent;
  }

  inputChanged() {
    this.updateSubmitButtonState();
  }
}
